/* unplugin-vue-components disabled */import { render } from "./MicroHeadlinesList.vue?vue&type=template&id=0cff6d60&scoped=true"
import script from "./MicroHeadlinesList.vue?vue&type=script&lang=js"
export * from "./MicroHeadlinesList.vue?vue&type=script&lang=js"

import "./MicroHeadlinesList.vue?vue&type=style&index=0&id=0cff6d60&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cff6d60"]])

export default __exports__